import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  claimCardContainer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#F0F8FF",
    padding: "20px",
    margin:"0px 4px",
    borderRadius: "20px",
  },
  marginBottom:{
    marginBottom:"20px",
  },
  network: {
    margin: 0,
    padding: 0,
    // fontSize: "14px",
    fontWeight: "600px",
  },
  iconBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  mContentText: {
    margin: 0,
    padding: 0,
    fontSize: "18px",
    fontWeight: "700px",
  },
  amountBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  amountText: {
    margin: 0,
    padding: 0,
    // fontSize: "18px",
    fontWeight: "600px",
  },
  amountNo: {
    margin: 0,
    padding: 0,
    fontSize: "25px",
    fontWeight: "700px",
  },
  claimBtn: {
    backgroundColor: "#FFDF00",
    color: "#000",
    borderRadius: "100px",
    // height: "60px",
    padding:"10px 20px",
    fontSize: "16px",
    fontWeight: "bold",
    "&:hover":{
      backgroundColor: "#f7d905",
      boxShadow:"0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)"
    }
  },
}));
